<template>
  <div class="yingyong">
      <div class="inner" v-if="menus() && menus().includes('zixun#q0')">
        <!-- 大会发布 -->
        <div class="pub-title" id="q0">
          <span>{{ $t('publications') }}</span>
        </div>
        <div class="content content6">
          <div class="item" v-for="(item, index) in newsList1" :key="index" @click="yingyong1(item, index)">
              <img class="img" :src="item.journalismCoverPc" v-if="isPc" alt="">
              <img class="img" :src="item.journalismCoverPhone" v-else alt="">
              <div class="text">
                <div class="title ellipsis2">{{ item['journalismTitle' + En] }}</div>
                <div class="addr">
                  <img src="https://static.worldaic.com.cn/2024/web/static/images/clock.png" alt="">
                  <span>{{ item.releaseTime }}</span>
                </div>
              </div>
            </div>
        </div>
        <el-pagination
          @current-change="handleCurrentChange1"
          :current-page.sync="pageNum1"
          :page-size="6"
          :layout="pageLayout"
          :pager-count="isPc ? 7 : 3"
          :total="total1">
        </el-pagination>
      </div>
      <div class="kongbai" v-if="menus() && menus().includes('zixun#q1')" id="q1"></div>
      <div class="inner" v-if="menus() && menus().includes('zixun#q1')">
        <!-- 行业新闻 -->
        <div class="pub-title">
          <span>{{ $t('zixun1') }}</span>
        </div>
        <div class="content content6">
          <div class="item" v-for="(item, index) in newsList2" :key="index" @click="yingyong2(item, index)">
              <img class="img" :src="item.journalismCoverPc" v-if="isPc" alt="">
              <img class="img" :src="item.journalismCoverPhone" v-else alt="">
              <div class="text">
                <div class="title ellipsis2">{{ item['journalismTitle' + En] }}</div>
                <div class="addr">
                  <img src="https://static.worldaic.com.cn/2024/web/static/images/clock.png" alt="">
                  <span>{{ item.releaseTime }}</span>
                </div>
              </div>
            </div>
        </div>
        <el-pagination
          @current-change="handleCurrentChange2"
          :current-page.sync="pageNum2"
          :page-size="6"
          :layout="pageLayout"
          :pager-count="isPc ? 7 : 3"
          :total="total2">
        </el-pagination>
      </div>
      <div class="kongbai" v-if="menus() && menus().includes('zixun#q2')" id="q2"></div>
      <div class="inner" v-if="menus() && menus().includes('zixun#q2')">
        <!-- 精彩瞬间 -->
        <div class="pub-title">
          <span>{{ $t('zixun2') }}</span>
        </div>
        <div class="content">
          <div class="item item1" v-for="(item, index) in newsList" :key="index" @click="yingyong3(item, index)">
              <img class="img" :src="item.journalismCoverPc" v-if="isPc" alt="">
              <img class="img" :src="item.journalismCoverPhone" v-else alt="">
              <div class="text">
                <div class="title ellipsis2">{{ item['journalismTitle' + En] }}</div>
              </div>
              <div class="mask">
                <img src="https://static.worldaic.com.cn/2024/web/static/images/play-icon.png" alt="">
              </div>
            </div>
        </div>
        <el-pagination
          @current-change="handleCurrentChange4"
          :current-page.sync="pageNum4"
          :page-size="6"
          :layout="pageLayout"
          :pager-count="isPc ? 7 : 3"
          :total="total4">
        </el-pagination>
        <div class="kongbai"></div>
        <!-- 精彩图库 -->
        <div class="content content1">
          <div class="item item2" v-for="(item, index) in imagesList" :key="index" @click="yingyong5(item, index)">
              <img class="img" :src="item.fileUrl" alt="">
              <div class="tuku">
                <span>{{ item.fileTitle }}</span>
              </div>
          </div>
        </div>
        <el-pagination
          @current-change="handleCurrentChange5"
          :current-page.sync="pageNum5"
          :page-size="8"
          :layout="pageLayout"
          :pager-count="isPc ? 7 : 3"
          :total="total5">
        </el-pagination>
      </div>
      <div class="kongbai" v-if="menus() && menus().includes('zixun#q3')" id="q3"></div>
      <div class="inner" v-if="menus() && menus().includes('zixun#q3')">
        <!-- 专题报道 -->
        <div class="pub-title">
          <span>{{ $t('zixun3') }}</span>
        </div>
        <div class="content content2">
          <div class="item" v-for="(item, index) in specialList" :key="index" @click="yingyong4(item, index)">
              <img class="img" :src="item.enterpriseLogoPc" v-if="isPc" alt="">
              <img class="img" :src="item.enterpriseLogoPhone" v-else alt="">
              <div class="text">
                <div class="title ellipsis2" style="height: auto">{{ item['briefDesc' + En] }}</div>
              </div>
            </div>
        </div>
        <el-pagination
          @current-change="handleCurrentChange3"
          :current-page.sync="pageNum3"
          :page-size="6"
          :layout="pageLayout"
          :pager-count="isPc ? 7 : 3"
          :total="total3">
        </el-pagination>
      </div>
      <div class="big-pc" v-if="bigPicImg">
        <img :src="bigPicImg" alt="" class="img">
        <img src="https://static.worldaic.com.cn/2024/web/static/images/forum-close.png" @click="bigPicImg = ''" class="close" alt="" />
      </div>
  </div>
</template>

<script>
import protal from "@/api/protal";
export default {
  data() {
    return {
      newsList1: [],
      newsList2: [],
      specialList: [],
      newsList: [],
      imagesList: [],
      newsTit1: {},
      newsTit2: {},
      swiperOptions: {
        loop: true,
        autoplay: {
          delay: 2000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        // 播放的速度
        speed: 1000,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      ConferenceGallery: "",
      topics: "",
      moments: "",
      readMore: "",
      pageNum: 0,
      total: -1,
      pageNum1: 1,
      total1: 0,
      pageNum2: 1,
      total2: 0,
      pageNum3: 1,
      total3: 0,
      pageNum4: 1,
      total4: 0,
      pageNum5: 1,
      total5: 0,
      bigPicImg: '',
    };
  },
  async created() {
    this.pageView('gw_zixunpage')
    await protal.getZdType("journalism_type").then((res) => {
      if (res && res.data && res.data.length) {
        this.typeList = res.data;
        this.newsTit1 = this.typeList[0];
        this.newsTit2 = this.typeList[1];
      }
    });
    this.getData1();
    this.getData2();
    this.getData3();
    this.getData4();
    this.getData5();
  },
  methods: {
    yingyong1(item, index) {
      this.gio(item, index, this.pageNum1, '大会发布')
      this.$router.push({ name: 'fabu', query: { uuid: item.uuid } })
    },
    yingyong2(item, index) {
      this.gio(item, index, this.pageNum2, '行业新闻')
      this.$router.push({ name: 'fabu', query: { uuid: item.uuid } })
    },
    yingyong3(item, index) {
      this.gio(item, index, this.pageNum3, '精彩瞬间')
      this.$router.push({ name: 'fabu', query: { uuid: item.uuid } })
    },
    yingyong5(item, index) {
      this.gio(item, index, this.pageNum5, '精彩瞬间（图库）', 'fileTitle')
      this.bigPic(item)
    },
    yingyong4(item, index) {
      this.gio(item, index, this.pageNum4, '专题报道', 'enterpriseName')
      this.toZt(item)
    },

    async gio(item, index, pageNum, str, name) {
      // console.log(item.dataTagRes, '标签')
      // let arr = item.dataTagRes || []
      // arr = arr.map(x => x.dataTag)
      // let industryFirstCate_var = this.labels.filter(x => arr.includes(x.uuid)).map(x => x.lableDesc).join('|')
      this.$jsAPI('track','informationContent',
          {
            'contentName_var': name ? item[name] : item.journalismTitle,
            'contentModule_var': str,
            // 'industryFirstCate_var': industryFirstCate_var ? '|' + industryFirstCate_var + '|' : '无',
            // 'industrySecCate_var': '无',
            'industryFirstCate_var': this.getFirstLabel(item.dataTagTwoRes),
            'industrySecCate_var': await this.getSecLabel(item.dataTagTwoRes),
            'pagination_var': pageNum + '',
            'position_var': `${pageNum}-${index + 1}`,
            'contentid': item.uuid
          }
      );
      gio('track','informationContent',
          {
            'contentName_var': name ? item[name] : item.journalismTitle,
            'contentModule_var': str,
            'industryCate_var': this.getFirstLabel(item.dataTagTwoRes),
            'industryFirstCate_var': await this.getSecLabel(item.dataTagTwoRes),
            'pagination_var': pageNum + '',
            'position_var': `${pageNum}-${index + 1}`,
          }
      );
    },
    bigPic(item) {
      this.bigPicImg = item.fileUrl
    },
    toZt(item) {
      window.open(item.enterpriseUrl, '_blank')
    },
    handleCurrentChange1(v) {
      this.pageNum1 = v
      this.getData1()
    },
    handleCurrentChange2(v) {
      this.pageNum2 = v
      this.getData2()
    },
    handleCurrentChange3(v) {
      this.pageNum3 = v
      this.getData3()
    },
    handleCurrentChange4(v) {
      this.pageNum4 = v
      this.getData4()
    },
    handleCurrentChange5(v) {
      this.pageNum5 = v
      this.getData5()
    },
    getData1() {
      let newsObj1 = {
        journalismType: this.newsTit1.uuid,
        pageNum: this.pageNum1,
        pageSize: 6,
        isWonderfulMoment: 1,
        viewTypes: this.En ? [2] : [1]
      };
      protal.queryJournalismList(newsObj1).then((res) => {
        if (res && res.data && res.data.length) {
          this.total1 = res.total
          this.newsList1 = res.data;
          this.setSuccessNum()
        }
      });
    },
    getData2() {
      let newsObj2 = {
        journalismType: this.newsTit2.uuid,
        pageNum: this.pageNum2,
        pageSize: 6,
        isWonderfulMoment: 1,
        viewTypes: this.En ? [2] : [1]
      };
      protal.queryJournalismList(newsObj2).then((res) => {
        if (res && res.data && res.data.length) {
          this.total2 = res.total
          this.newsList2 = res.data;
          this.setSuccessNum()
        }
      });
    },
    getData3() {
      // 大会专题
      protal
        .queryPartnersList({ isSpecial: 0, partnersType: "", pageNum: this.pageNum3, pageSize: 6 })
        .then((res) => {
          if (res && res.data && res.data.length) {
            this.total3 = res.total
            this.specialList = res.data
            this.setSuccessNum()
          }
        });
    },
    getData4() {
      let params = {
        journalismType: "",
        pageNum: this.pageNum4,
        pageSize: 6,
        isWonderfulMoment: 0,
        viewTypes: this.En ? [2] : [1]
      };
      protal.queryJournalismList(params).then((res) => {
        if (res && res.data && res.data.length) {
          this.newsList = res.data || [];
          this.total4 = res.total;
          this.setSuccessNum()
        }
      });
    },
    getData5() {
      let imgParams = {
        fileType: 323,
        pageNum: this.pageNum5,
        pageSize: 8,
        showType: this.En ? 2 : 1
      };
      protal.queryOfficialFileList(imgParams).then((res) => {
        if (res && res.data && res.data.length) {
          this.imagesList = res.data || [];
          this.total5 = res.total;
          this.setSuccessNum()
        }
      });
    },
    specialHref(ite) {
      window.open(ite.enterpriseUrl, "_blank")
    },
    // 查看更多
    moreNews(type) {
      this.$router.push({ path: "/newsList", query: { type: type } });
    },
    // 新闻详情
    newsdetail(uuid) {
      this.$router.push({ path: "/newsdetail", query: { uuid: uuid } });
    },
    // 精彩时刻
    goMomonts() {
      this.$router.push("/moments");
    },
    // 大会图片库
    goImages() {
      this.$router.push("/gallery");
    },
    partnerClick(url) {
      window.open(url, "_blank");
    },
    
  },
  watch:{
    En() {
      this.getData()
    },
  }
};
</script>

<style lang="less" scoped>
.yingyong {
  background-image: url(https://static.worldaic.com.cn/2024/web/static/images/zixun-bg.jpg);
}
@media screen and (min-width: 769px) {
  .big-pc {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 999;
    padding: 0 1.49rem;
    background: rgba(0, 0, 0, 0.8);

    .img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .close {
      position: absolute;
      right: .4rem;
      top: .4rem;
      width: .54rem;
      height: .54rem;
      cursor: pointer;
    }
  }

  .item2 {

    .tuku {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: url(https://static.worldaic.com.cn/2024/web/static/images/tuku.png);
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 .2rem;
      font-size: .36rem;
      line-height: 1.8;
      color: #fff;
      opacity: 0;
      transition: .5s;

      &:hover {
        opacity: 1;
      }
    }
  }
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .big-pc {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 999;
    padding: 2rem 0;
    background: rgba(0, 0, 0, 0.8);

    .img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .close {
      position: absolute;
      left: 50%;
      bottom: 1rem;
      transform: translateX(-50%);
      width: .8rem;
      height: .8rem;
      cursor: pointer;
    }
  }

  .item2 {

    .tuku {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: url(https://static.worldaic.com.cn/2024/web/static/images/tuku.png);
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 .2rem;
      font-size: .32rem;
      line-height: 1.8;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/zixun/index.vue